import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import '@icms/core/data/icms-data.interfaces';

/**
 * Page additional fields
 */

ICmsContentService.registerPageMetaPatch(pageMeta => {
    pageMeta?.fields?.push({
        key: 'additional.hideHubspot',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Hide Hubspot',
        default: false,
        tab: 'Additional Configuration'
    });
});

declare module '@icms/core/data/icms-data.interfaces' {
    namespace NICmsData {
        interface ICmsAdditionalData {
            hideHubspot?: boolean;
        }
    }
}
